import { Vue, Component, Prop } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';
import * as icons from './icons';

@Component({
  name: 'Icon',
  computed: {
    hasClickListener(): boolean {
      return Boolean(this.$listeners.click || this.$listeners['!click']);
    },
  },
})
class Icon extends Vue {
  @Prop({type: String}) public name!: string;
  @Prop({type: Number}) public size!: number;
  private hasClickListener: any;

  public render(createElement: CreateElement): VNode {
    return createElement(this.hasClickListener ? 'button' : 'span', {
      style: [
        !this.size && {width: `${this.size}px`},
        !this.size && {height: `${this.size}px`},
      ],
      domProps: {
        innerHTML: icons[this.name],
      },
    });
  }
}

export { Icon };
export default Icon;
